const items = document.querySelectorAll('.related-services-section__item ');
if (items.length > 0) {
    items[0].classList.add('active');
}


items.forEach((service, i, arr) => {
    service.addEventListener('mouseenter', () => {
        arr.forEach((s) => s.classList.remove('active'));
        service.classList.add('active');
    });

    service.addEventListener('mouseleave', () => {
        service.classList.remove('active');
    });
});
